import { render, staticRenderFns } from "./TaskBoardWrapper.vue?vue&type=template&id=6b49f997&"
import script from "./TaskBoardWrapper.vue?vue&type=script&lang=js&"
export * from "./TaskBoardWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports